import AppLayout from "../components/layout/AppLayout";
import DocumentTableComponent from "../components/document/DocumentTableComponent";

export default function VehiclewiseDocument() {
  return (
    <AppLayout>
      <DocumentTableComponent category="vehiclewise" />
    </AppLayout>
  );
}
